module.exports = __webpack_public_path__ + "assets/img/sbac_header_top_profile.webp?0f8f6e4e880734660f24f1b3cf8774b8";